import apiClient from '../apiClient'

export default {
  async getCurrentWeather(cityId, params = {}) {
    return await apiClient.get(
      apiClient.url('/weather/cities/{id}', { id: cityId }),
      params,
    )
  },
  async getDailyForecast(cityId, params = {}) {
    return await apiClient.get(
      apiClient.url('/weather/forecast/daily/cities/{id}', { id: cityId }),
      params,
    )
  },
  async getHourlyForecast(cityId, params = {}) {
    return await apiClient.get(
      apiClient.url('/weather/forecast/hourly/cities/{id}', { id: cityId }),
      params,
    )
  },

  async getCurrentWeatherByDeliveryPoint(deliveryPointId, params = {}) {
    return await apiClient.get(
      apiClient.url('/operation/delivery-points/{id}/weather', {
        id: deliveryPointId,
      }),
      params,
    )
  },
  async getDailyForecastByDeliveryPoint(deliveryPointId, params = {}) {
    return await apiClient.get(
      apiClient.url('/operation/delivery-points/{id}/weather/forecast/daily', {
        id: deliveryPointId,
      }),
      params,
    )
  },
  async getHourlyForecastByDeliveryPoint(deliveryPointId, params = {}) {
    return await apiClient.get(
      apiClient.url('/operation/delivery-points/{id}/weather/forecast/hourly', {
        id: deliveryPointId,
      }),
      params,
    )
  },

  async getDeviceDataByDeviceId(deviceId, params = {}) {
    return await apiClient.get(
      apiClient.url('/operation/devices/{deviceId}/device-data', {
        deviceId: deviceId,
      }),
      params,
    )
  },
  async getDeviceDataByDeliveryPointId(deliveryPointId, params = {}) {
    return await apiClient.getWithFilterParams(
      apiClient.url(
        '/operation/delivery-points/{deliveryPointId}/device-data',
        { deliveryPointId: deliveryPointId },
      ),
      params,
    )
  },
  async getDeviceDataSummaryByDeliveryPointId(deliveryPointId, params = {}) {
    return await apiClient.get(
      apiClient.url(
        '/operation/delivery-points/{deliveryPointId}/device-data/summary',
        { deliveryPointId: deliveryPointId },
      ),
      params,
    )
  },
  async downloadWeatherExcelExport(id) {
    return await apiClient.download(
      apiClient.url('/weather/by-city/{city}/export/excel', { city: city }),
    )
  },
  /**
   *
   * @param deliveryPointId
   * @param formData {FormData}
   * @return {Promise<AxiosResponse<any>>}
   */
  async importDeviceDataFromExcel(deliveryPointId, formData) {
    return await apiClient.upload(
      apiClient.url(
        '/operation/delivery-points/{id}/device-data/import/excel',
        { id: deliveryPointId },
      ),
      formData,
    )
  },
  async createDeliveryPoint(data = {}) {
    return await apiClient.post(
      apiClient.url('/operation/delivery-points'),
      data,
    )
  },
  async updateDeliveryPoint(deliveryPointId, data = {}) {
    return await apiClient.put(
      apiClient.url('/operation/delivery-points/{id}', { id: deliveryPointId }),
      data,
    )
  },
  async getDeliveryPoint(deliveryPointId) {
    return await apiClient.put(
      apiClient.get('/operation/delivery-points/{id}', {
        irDisablingContentString: deliveryPointId,
      }),
    )
  },
  async createDeliveryPointNote(data = {}) {
    return await apiClient.post(
      apiClient.url('/operation/delivery-points/notes'),
      data,
    )
  },
  async updateDeliveryPointNote(id, data = {}) {
    return await apiClient.put(
      apiClient.url('/operation/delivery-points/notes/{id}', { id: id }),
      data,
    )
  },
  async getDeliveryPointNote(id) {
    return await apiClient.get(
      apiClient.url('/operation/delivery-points/notes/{id}', { id: id }),
    )
  },
  async deleteDeliveryPointNote(id) {
    return await apiClient.delete(
      apiClient.url('/operation/delivery-points/notes/{id}', { id: id }),
    )
  },
  async findDeliveryPointNotes(params = {}) {
    return await apiClient.get(
      apiClient.url('/operation/delivery-points/notes'),
      params,
    )
  },
  async getDeliveryPointNoteAuditLogs(id, params = {}) {
    return await apiClient.get(
      apiClient.url('/operation/delivery-points/notes/{id}/audit/logs', {
        id: id,
      }),
      params,
    )
  },
  async createDevice(data = {}) {
    return await apiClient.post(apiClient.url('/operation/devices'), data)
  },
  async updateDevice(id, data = {}) {
    return await apiClient.put(
      apiClient.url('/operation/devices/{id}', { id: id }),
      data,
    )
  },
  async getDevice(id) {
    return await apiClient.get(
      apiClient.url('/operation/devices/{id}', { id: id }),
    )
  },
  async getDeviceAuditLogs(id, params = {}) {
    return await apiClient.get(
      apiClient.url('/operation/devices/{id}/audit/logs', { id: id }),
      params,
    )
  },
  async findDevicesByDeliveryPointId(deliveryPointId, params = {}) {
    return await apiClient.get(
      apiClient.url('/operation/delivery-points/{id}/devices', {
        id: deliveryPointId,
      }),
      params,
    )
  },
  /**
   *
   * @param username
   * @param password
   * @return {Promise<string|null>} token
   */
  authenticate: async function (username, password) {
    let response = await apiClient.post('/users/auth', {
      username: username,
      password: password,
    })

    return response.data?.token ?? null
  },
  async createDeviceData(data = {}) {
    return await apiClient.post(apiClient.url('/operation/device-data'), data)
  },
  async updateDeviceData(id, data = {}) {
    return await apiClient.put(
      apiClient.url('/operation/device-data/{id}', { id: id }),
      data,
    )
  },
  async getDeviceData(id) {
    return await apiClient.get(
      apiClient.url('/operation/device-data/{id}', { id: id }),
    )
  },
  async getDeviceDataExcelExportByDeliveryPointId(id, params = {}) {
    return await apiClient.download(
      apiClient.url(
        '/operation/delivery-points/{id}/device-data/export/excel',
        { id: id },
      ),
      params,
    )
  },
  async getWeatherHourlyExcelExportByDeliveryPointId(id, params = {}) {
    return await apiClient.download(
      apiClient.url(
        '/operation/delivery-points/{id}/weather/hourly/export/excel',
        { id: id },
      ),
      params,
    )
  },
  async deleteDeliveryPointDeviceData(id, params = {}) {
    return await apiClient.delete(
      apiClient.url('/operation/delivery-points/{id}/device-data', { id: id }),
      params,
    )
  },
}
